import { TableActionMenu, type TableActionItem } from '@/components/shared';

export interface LinksFiltersProps {
  query: string;
  status: string;
  targetType: string;
  actions?: TableActionItem[];
  onQueryChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onTargetTypeChange: (value: string) => void;
}

export function LinksFilters({
  query,
  status,
  targetType,
  actions = [],
  onQueryChange,
  onStatusChange,
  onTargetTypeChange,
}: LinksFiltersProps) {
  return (
    <div className="flex flex-wrap items-stretch gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4 sm:items-end">
      <label className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[260px]">
        Search
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search slug"
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        />
      </label>

      <label className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[170px]">
        Status
        <select
          value={status}
          onChange={(event) => onStatusChange(event.target.value)}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          <option value="active">Active</option>
          <option value="archived">Archived</option>
          <option value="all">All</option>
        </select>
      </label>

      <label className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[190px]">
        Target type
        <select
          value={targetType}
          onChange={(event) => onTargetTypeChange(event.target.value)}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          <option value="all">All targets</option>
          <option value="external_url">External URL</option>
          <option value="internal_url">Internal URL</option>
          <option value="study">Study</option>
        </select>
      </label>

      {actions.length > 0 ? (
        <div className="flex w-full justify-end sm:ml-auto sm:w-auto">
          <TableActionMenu actions={actions} label="Link table actions" />
        </div>
      ) : null}
    </div>
  );
}
